/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const SearchFieldContainer = styled.div<{
  widthGridMultiplier?: number;
}>(props => ({
  width: `${props.widthGridMultiplier ? 8 * props.widthGridMultiplier : 240}px`,
  '& > div': {
    height: '32px',
    '&:focus, &:hover': {
      height: '32px',
    },
  },
}));

export const SearchIconContainer = styled.span({
  paddingRight: token('space.100'),
  paddingTop: token('space.025'),
});

export const HeaderCheckbox = styled.span({
  verticalAlign: 'bottom',
});

export const BulkActionsHeader = styled.div({
  color: token('color.text'),
  font: token('font.body'),
  '& button:nth-of-type(2), & button:nth-of-type(3)': {
    marginLeft: token('space.150'),
  },
});
